import { createSlice } from "@reduxjs/toolkit";

const slaState = {
  loader: false,
  milestones: [],
  paymentSchedule: [],
  owners: [
    { id: "1", value: "PSP" },
    { id: "2", value: "Client" },
  ],
  selectedMilestones: [],
  fetchSelectMilestoneLoader: false,
  selectedCalendarDates: [],
  createTemplateLoader: false,
  templateUpdated: false,
  templateUsers: [],
};

const slaSlice = createSlice({
  name: "SLA",
  initialState: slaState,
  reducers: {
    addMilestone(state, action) {
      state.selectedMilestones.push(action.payload);
    },
    updateMilestoneBegins(state, action) {
      state.fetchSelectMilestoneLoader = action.payload;
    },
    updateMilestone(state, action) {
      state.selectedMilestones = action.payload;
    },
    updateCreationLoader(state, action) {
      state.createTemplateLoader = action.payload;
    },
    templateChangedForClient(state, action) {
      state.templateUpdated = action.payload;
    },
    updateClientUsers(state, action) {
      state.templateUsers = action.payload;
    },
  },
});

export const {
  addMilestone,
  updateMilestoneBegins,
  updateMilestone,
  updateCreationLoader,
  templateChangedForClient,
  updateClientUsers,
} = slaSlice.actions;

export default slaSlice.reducer
